
import { 
    STATUS, 
    GSM_CHARACTERS, 
    DAYS,
    SEND_RECIPIENT_LIMIT,
    SEND_RECIPIENT_LIMIT_IN_SEC
} from "@interfaces/enum";
import htmlTags from 'html-tags';

const errorMessage = function (response, title = null) {
    let message = '';
    if (_.isObject(response)) {
        _.forEach(response, (data, key) => {
            message += "<div class='alert alert-danger' role='alert'>";
            message += _.join(data, " ");
            message += "</div>";
        });
    } else {
        message += "<div class='alert alert-danger' role='alert'>";
        message += response;
        message += "</div>";
    }
    Swal.fire({
        title: title ? title : 'Error!',
        html: message,
        icon: 'error',
        width: 400
    });
}
const getStatus = function (status, type = "bg") {
    let color = "";
    switch (status) {
        case STATUS.PENDING:
        case STATUS.UNPAID:
        case STATUS.FOR_APPROVAL:
            color = "-warning";
            break;
        case STATUS.ACTIVATED:
        case STATUS.PAID:
        case STATUS.DONE:
            color = "-success";
            break;
        case STATUS.APPROVED:
            color = "-primary";
            break;
        case STATUS.CANCELLED:
        case STATUS.DECLINED:
        case STATUS.EXPIRED:
        case STATUS.FAILED:
            color = "-danger";
            break;
        case STATUS.REFUNDED:
        case STATUS.DELETED:
        case STATUS.TRANSACTION_PENDING:
            color = "-dark";
            break;


        default:
            break;
    }
    return `${type}${color}`;
}
const checkingApiRequest = function (state, method) {

    var cancelToken = state.cancelSources[method];
    if (!_.isEmpty(cancelToken)) {
        cancelToken.cancel()
    }
    var payload = {
        method: method,
        newToken: axios.CancelToken.source()
    }
    state.cancelSources[method] = axios.CancelToken.source();
    // commit('setCancelSources', payload)

}

const isOdd = function (value) {
    return Math.abs(value % 2) == 1;
}

const removeNonGsmCharset = function (string) {
    var gsm = GSM_CHARACTERS; //"@ £$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞ^{}\[~]|€ÆæßÉ!\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
            
    if (gsm) {
        var letters = string.split('');
        
        _.forEach(letters, letter => {
            var check = gsm.indexOf(letter) !== -1;
            if (!check) {
                string = string.replace(letter,"<span class='bg-danger text-white py-1 px-2'>"+letter+"</span>")
            }
        });
    }

    // Regular expression to match invalid HTML entities (e.g., &frac12 without a semicolon)
    const invalidEntityPattern1 = /&([a-zA-Z0-9]+)(?![a-zA-Z0-9]*;)/g;

    // Replace invalid HTML entities with a red-colored span (styled)
    string = string.replace(invalidEntityPattern1, (match, p1) => {
        return match != "&nbsp" ? `<span class='bg-danger text-white py-1 px-2'>${_.escape(match)}</span>` : match; // Wrap invalid entities in a red span
    });

    string = checkValidHtmlTags(string);

    return string;
}

const checkValidHtmlTags = function (str) {
    // Regular expression to match HTML tags
    const regex = /<\/?([a-zA-Z]+)([^>]*>)/g;
    // Replace tags if they are not valid HTML tags
    return str.replace(regex, (match, tagName) => {
        // If the tag is valid, leave it as is, otherwise replace with a styled <span>
        if (htmlTags.includes(tagName.toLowerCase())) {
            return match; // Keep valid HTML tags as is
        } else {
            return `<span class='bg-danger text-white py-1 px-2'>${_.escape(match)}</span>`; // Replace invalid tags with styled span
        }
    });
}

const replaceAll = function (string, target, replacement) {
    if (string) {
        string = _.replace(string, new RegExp(target, "g"), replacement);
    }
    
    return string;
}

const formatAppointmentSchedule = function (appointment) {
    let schedule = appointment.doctor_schedule; 
    let appointment_date = appointment.appointment_date;
    let reschedule = appointment.reschedule ? appointment.reschedule : getAppointmentReschedule(appointment);
    const time = formatTime(appointment_date);
    let sched = "";
    let last_sched = "";

    if (appointment_date && appointment_date != "0000-00-00 00:00:00") {
        if (reschedule) {

            sched += formatDay(appointment_date);
            if (formatTime(appointment_date)!='12:00am') {
                sched += ", " + formatTime(appointment_date);
            } else {
                sched += ", Any time of the day";
            }
            sched += ", " + moment(appointment_date).format("MMM D, YYYY");

            if (schedule) {
                if (schedule.day) {
                    last_sched += getDayName(schedule.day);
                }                    
                if (schedule.from_day || schedule.to_day) {
                    last_sched += ", " + schedule.from_day + " - " + schedule.to_day;
                } else { 
                    if (schedule.availability) {
                        last_sched += ", Whole " + _.capitalize(schedule.availability);
                    } else {
                        last_sched += ", Any time of the day";
                    }
                }
            } else {
                last_sched += formatDay(reschedule);
                if (reschedule.time!='null') {
                    last_sched += ", " + reschedule.time;
                } else {
                    last_sched += ", Any time of the day";
                }
            }
            
            last_sched += ", " + moment(reschedule.reschedule).format("MMM D, YYYY");
        } else {
            if (schedule) {
                if (schedule.day) {
                    sched += getDayName(schedule.day);
                }                    
                if (schedule.from_day || schedule.to_day) {
                    if (formatTime(appointment_date)!='12:00am') {
                        sched += ", " + formatTime(appointment_date);
                    } else {
                        sched += ", " + schedule.from_day + " - " + schedule.to_day;
                    }
                } else { 
                    if (formatTime(appointment_date)!='12:00am') {
                        sched += ", " + formatTime(appointment_date);
                    } else {
                        if (schedule.availability) {
                            sched += ", Whole " + _.capitalize(schedule.availability);
                        } else {
                            sched += ", Any time of the day";
                        }
                    }
                }
            } else {
                sched += formatDay(appointment_date);
                if (formatTime(appointment_date)!='12:00am') {
                    sched += ", " + formatTime(appointment_date);
                } else {
                    sched += ", Any time of the day";
                }
            }
            
            sched += ", " + moment(appointment_date).format("MMM D, YYYY");
        }
    } else {                
        sched += "N/A";
    }

    return {
        sched,
        last_sched
    };
}

const getDayName = function (day) {
    const day_key = _.findIndex(DAYS, { value: day });
    return DAYS[day_key].text;
}

const formatTime = function (value) {
    return !_.isEmpty(value)
        ? moment(value).format("h:mma")
        : null;
}

const formatDay = function (value) {
    return !_.isEmpty(value)
        ? moment(value).format("dddd")
        : null;
}

const formatDate = function (value) {
    return value 
    ? moment(value).format("YYYY-MM-DD") 
    : null
}

const getAppointmentReschedule = function (item) {
    let reschedule = null;
    var remarks = item.remarks;

    if (_.includes(remarks, 'reschedule:')) {
        reschedule = _.split(remarks, ":");
        var i = 1;
        var reschedule_arr = {}
        _.forEach(reschedule, item => {
            if (isOdd(i)) {
                if (item=='time') {
                    reschedule_arr[item] = reschedule[i].replace("-", ":");
                    reschedule_arr[item] = reschedule_arr[item].replace(" ", "");
                    reschedule_arr[item] = _.toLower(reschedule_arr[item])
                } else {
                    reschedule_arr[item] = reschedule[i]
                }
            }
            i++;
        });
        reschedule = reschedule_arr;
    }        
    return reschedule;
}

const getUserStatus = function (item) {
    let label = "";
    let badge = "";
    if (!item.deleted_at) {
        if (item.active) {
            label = "ACTIVE";
            badge = "badge-success";
        } else {
            label = "DEACTIVATED";
            badge = "badge-danger";
        }
    } else {
        label = "DELETED";
        badge = "badge-dark";
    }
    return {
        label,
        badge
    }
}

const addAll = function (end) {
    const start = [{ value: null, text: "All" }];
    return start.concat(end);
}

// Announcement
const getETC = function (date, overall, limit, seconds, add) {
    let completed = _.round((overall/limit) * seconds);
    let estimated = moment(date).add(completed, 'seconds');
    return moment(estimated).add(add, 'minutes');
}

const getETCStatus = function (etc, date) {
    // Ensure 'etc' and 'date' parameters are valid date strings
    if (!moment(etc, moment.ISO_8601, true).isValid() || !moment(date, moment.ISO_8601, true).isValid()) {
        // Handle invalid date strings appropriately
        return {
            status: 'invalid',
            color: 'error'
        };
    }

    // Parse 'etc' and 'date' parameters using Moment.js
    const etc_datetime = moment(etc);
    const schedule = moment(date);
    const current_datetime = moment();

    // Check if 'etc_datetime' is before 'current_datetime'
    const isBeforeCurrent = etc_datetime.isBefore(current_datetime);
    // Check if 'current_datetime' is between 'schedule' and 'etc_datetime'
    const isBetweenSchedule = current_datetime.isBetween(schedule, etc_datetime);

    // Determine status based on conditions
    let status;
    if (isBetweenSchedule) {
        status = 'on-going';
    } else if (isBeforeCurrent) {
        status = 'done';
    } else {
        status = 'pending';
    }

    // Determine color based on status
    let color;
    switch (status) {
        case 'on-going':
            color = 'success';
            break;
        case 'done':
            color = 'primary';
            break;
        case 'pending':
            color = 'warning';
            break;
        default:
            color = 'error';
    }

    return {
        status,
        color
    };
};

// Date
const dateDuration = function (end, start = moment(new Date())) {
    if (!end) return '';
    var duration = moment.duration((moment(end)).diff(start));
    return duration.asHours();
}

const dateIsAfter = function (date) {
    if (!date) return false;
    return moment().isAfter(date);
}  

const checkDateRangeStatus = function (start_at, end_at) {
    const now = new Date();
    const startAt = new Date(start_at);
    const endAt = new Date(end_at);

    // Normalize the dates to ignore time part
    now.setHours(0, 0, 0, 0);
    startAt.setHours(0, 0, 0, 0);
    endAt.setHours(0, 0, 0, 0);

    if (now < startAt) {
      return 'pending';
    } else if (now >= startAt && now <= endAt) {
      return 'on_going';
    } else {
      return 'expired';
    }
}  

const getDateRangeStatusColor = function (start_at, end_at) {
    const status = checkDateRangeStatus(start_at, end_at)
    let text_color = "";
    switch(status) {
        case "pending":
            text_color = "warning";
            break;
        case "on_going":
            text_color = "success";
            break;
        case "expired":
            text_color = "danger";
            break;
    }
    return text_color;
}

const getAuditName = function (params, name) {
    if (_.isEmpty(params[ name ].toString())) {
        return "";
    }

    let key = `${ name }_admin`;

    if (!_.isEmpty(params[ key ])) {
        if (!_.isEmpty(params[ key ].full_name)) {
            return params[ key ].full_name
        }
        return params[ key ].first_name + ' ' + params[ key ].last_name;
    }

    if (!_.isEmpty(params.admin)) {
        const { first_name, last_name } = params.admin
        return params.admin.first_name + ' ' + params.admin.last_name;
    }
}

const getImageSize = function (img, callback) {
    var image = new Image();
    image.src = img;
    image.onload = function() {
        var result = { 
            width: image.width, 
            height: image.height
        };
        callback(result);
    };
}

const getImageSizeExceedMessage = function (width, height, limit) {
    return "Image Dimensions Exceed Limit!<br>(Your image size: "+ width + " x " + height + ") <br>Please choose an image with dimensions within <b>" + limit + " x " + limit + "</b>"
}

const getText = function (array, value) {
    const data = _.find(array, { value })
    return data ? data.text : (value ?? null);
};

export default {
    errorMessage,
    checkingApiRequest,
    getStatus,
    isOdd,
    removeNonGsmCharset,
    replaceAll,
    formatAppointmentSchedule,
    getDayName,
    formatTime,
    formatDay,
    formatDate,
    getAppointmentReschedule,
    getUserStatus,
    addAll,
    getETC,
    getETCStatus,
    dateDuration,
    dateIsAfter,
    getAuditName,
    getImageSize,
    getImageSizeExceedMessage,
    getText,
    checkDateRangeStatus,
    getDateRangeStatusColor
}